<template>
  <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import VueCookies from 'vue-cookies'
import VueHighlightJS from 'vue-highlight.js'

Vue.use(VueCookies)
Vue.use(VueHighlightJS)

export default {
  name: 'app',
  created: function () {
    if (!this.$cookies.isKey('.jwt')) {
      store.commit('LOGOUT_USER')
      router.push('/login')
    }
  }
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
</style>
<style>
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  /* Import Highlight.js theme */
  @import 'highlight.js/styles/default.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue